var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"chart"},[_c('apexchart',{staticClass:"apexchart",attrs:{"options":_vm.chartOptions,"series":_vm.pieChartData,"type":"pie","height":"500"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }